(function () {
  angular.module('leanlaw').directive('llInvoiceListButtons', InvoiceListButtonsDirective).directive('llInvoiceListIcon', InvoiceListIconDirective);
  InvoiceListButtonsDirective.$inject = ['userService'];
  function InvoiceListButtonsDirective(userService) {
    return {
      restrict: 'EA',
      template: require('./views/invoiceListButtons.html'),
      scope: {
        options: '=',
        processing: '=',
        process: '&'
      },
      link: scope => {
        userService.me().then(me => {
          scope.me = me;
        });
        scope.select = function (option) {
          scope.process({
            $option: option
          });
        };
      }
    };
  }
  function InvoiceListIconDirective() {
    return {
      restrict: 'EA',
      template: require('./views/invoiceListIcon.html'),
      scope: {
        actions: '='
      }
    };
  }
})();